import React from 'react'
// import CurrentVisitors from './CurrentVisitors'
import DateFilter from './DateFilter'
import { Journey } from 'src/common/interfaces/journey.interface';

type WidgetProps ={
  journey: Journey
}

export default function Header({journey}: WidgetProps) {

  return (
    <header className="flex justify-between flex-col lg:flex-row gap-6">
      <div className="block gap-2 md:gap-10 justify-between md:justify-start space-y-4">
        <h1 className="flex items-center gap-2 min-w-max">
         
          <span className="text-lg leading-6 text-gray-800">{journey.name}</span>
        </h1>

        <div className="bg-white border-t-4 border-teal-400 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
  <div className="flex">
    <div className="py-1"><svg className="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
    <div className='space-y-2'>
      <p className="font-bold">Analytics Data Information</p>
      <p className="text-sm">Shows data after 05/22/2024 (22nd May 2024) when the analytics feature was enabled on Journey</p>
    </div>
  </div>
</div>
        {/* <CurrentVisitors /> */}
      </div>
      <DateFilter />
    </header>
  )
}
